export const EstateFormEnum = {
  TYPE_OF_PROPERTY: 'typeOfProperty',
  PROPERTY_TYPE_DETAIL: 'propertyTypeDetail',
  DESCRIPTION: 'description',
  VALUE: 'value',
} as const;

export const EstateCommonFormControlNames = {
  [EstateFormEnum.TYPE_OF_PROPERTY]: 'Type of Property',
  [EstateFormEnum.VALUE]: ' Property Value',
};

export const EstatePersonalPropertyFormControlNames = {
  [EstateFormEnum.DESCRIPTION]: 'Asset(s) Description',
} as const;

export const EstateRealPropertyFormControlNames = {
  [EstateFormEnum.PROPERTY_TYPE_DETAIL]: 'Property Type Detail',
  [EstateFormEnum.DESCRIPTION]: 'Property Address',
};
